/**
 * Route paths shared between a page and whatever links to it, so a link and
 * its <Route> can never drift apart.
 */

/** Full read-only ledger of the paper forward test's open positions. */
export const PAPER_POSITIONS_PATH = '/paper/positions'

/** A call's public page, viewable without signing in. */
export const CALL_PATH = '/r/:id'
export const callPath = (id: number) => `/r/${id}`

/**
 * A creator's public record: every call they locked. Routed by handle (display
 * only; the record is keyed by user id server-side). /c/ rather than
 * /creator/, which is the subscription profile keyed by id.
 */
export const CREATOR_RECORD_PATH = '/c/:handle'
export const creatorRecordPath = (handle: string) => `/c/${encodeURIComponent(handle)}`

/** The public fingerprint check for the whole record. */
export const VERIFY_PATH = '/verify'

/** The personal fee calculator: public, no login. */
export const FEE_CALCULATOR_PATH = '/fee-calculator'

/**
 * Where a "Track record" link goes. /track-record needs a login, so a
 * signed-out visitor goes to the fee calculator instead: it lists every
 * close, before fees at 0%.
 */
export const recordPath = (signedIn: boolean) => (signedIn ? '/track-record' : FEE_CALCULATOR_PATH)

/** Lock a call (behind LOCK_A_CALL_ENABLED; superusers only while it is on). */
export const MY_CALLS_PATH = '/calls'
export const LOCK_CALL_PATH = '/calls/new'
